import React from 'react';
import { Text } from '@eo-locale/react';
import { styled } from '@mui/material/styles';
import { usePopupState, bindToggle, bindPopper } from 'material-ui-popup-state/hooks';
import { classes } from '@guest-widgets/shared/src/classes';
import { Feature } from '@guest-widgets/shared/src/features';
import { useFeature } from '@guest-widgets/shared/src/contexts/featureContext/featureContext';

import { FilterButton } from '../FilterButton';
import { PriceFilter } from '../PriceFilter';
import { Sorting } from '../Sorting';
import { FilterSection } from '../FilterSection';
import { CheckboxList } from '../CheckboxList';
import { useFilterAttributes } from '../../../filterAttributesContext';
import { useFilters } from '../../../filtersContext/filtersContext';

import { Popper } from './Popper';

export const MoreFilters = () => {
  const { isEnabled } = useFeature();

  const { attributes } = useFilterAttributes();
  const {
    filters: { languages, misc },
    setLanguages,
    setMisc,
  } = useFilters();
  const popupState = usePopupState({ variant: 'popper', popupId: 'more-filters' });

  const sortingIsVisible = isEnabled(Feature.ProductSorting);

  const priceIsVisible =
    isEnabled(Feature.PriceFilter) &&
    attributes.isValid &&
    attributes.value?.maxPriceRange[0] < attributes.value?.maxPriceRange[1];

  const miscIsVisible =
    isEnabled(Feature.MiscellaneousFilter) &&
    attributes.isValid &&
    attributes.value?.miscOptions?.length > 0;

  const languageIsVisible =
    isEnabled(Feature.LanguageFilter) &&
    attributes.isValid &&
    attributes.value?.availableLanguages?.length > 0;

  const somethingIsVisible = [
    sortingIsVisible,
    priceIsVisible,
    miscIsVisible,
    languageIsVisible,
  ].some((value) => value);

  if (!somethingIsVisible) return null;

  // TODO: Today not implemented more filers and ordering but we expect some changes here
  return null;

  return (
    <>
      <FilterButton
        className={classes.catalog.filters.more.button}
        variant="outlined"
        isActive={popupState.isOpen}
        {...bindToggle(popupState)}
      >
        <Text id="product-catalog.filters.more-filters-title" />
      </FilterButton>

      <Popper
        className={classes.catalog.filters.more.popup}
        popperTitle="product-catalog.filters.more-filters-title"
        placement="bottom-end"
        popupState={popupState}
        {...bindPopper(popupState)}
      >
        <FilterSectionContainer>
          {sortingIsVisible && (
            <FilterSection
              title={<Text id="product-catalog.filters.sorting.title" />}
              className={classes.catalog.filters.sorting.root}
            >
              <Sorting />
            </FilterSection>
          )}

          {priceIsVisible && (
            <FilterSection
              title={<Text id="product-catalog.filters.price.title" />}
              className={classes.catalog.filters.price}
            >
              <PriceFilter />
            </FilterSection>
          )}

          {miscIsVisible && (
            <FilterSection
              title={<Text id="product-catalog.filters.miscellaneous" />}
              className={classes.catalog.filters.misc}
            >
              <CheckboxList
                filterValues={misc}
                attributeOptions={attributes.value.miscOptions}
                onSelect={setMisc}
              />
            </FilterSection>
          )}

          {languageIsVisible && (
            <FilterSection
              title={<Text id="product-catalog.filters.languages.title" />}
              className={classes.catalog.filters.languages}
            >
              <CheckboxList
                filterValues={languages}
                attributeOptions={attributes.value.availableLanguages}
                onSelect={setLanguages}
              />
            </FilterSection>
          )}
        </FilterSectionContainer>
      </Popper>
    </>
  );
};

const FilterSectionContainer = styled('div')(({ theme: { border, spacing } }) => ({
  '& > div': {
    borderBottom: border,
    margin: `${spacing(6)} -${spacing(4)} 0`,
  },
  '& > div:last-child': {
    borderBottom: 'none',
  },
}));
